/* global wpbp_app */
import jQuery from 'jquery';

jQuery($ => {
    let $body = $('body'),
        $loginBtn = $('.js-login');

    $loginBtn.on('click', event => {
        if (!$loginBtn.data('logged-in')) {
            event.preventDefault();
            $loginBtn.toggleClass('is-form-open');
            $body.toggleClass('is-login-form-open');
        }
    });

    $('#loginform-header')
        .on('submit', function (event) {
            event.preventDefault();

            let $form = $(this),
                $inputs = $form.find('input, button'),
                redirectUrl = $form.attr('action'),
                userName = $form.find('[name="log"]').val(),
                password = $form.find('[name="pwd"]').val(),
                remember = $form.find('[name="rememberme"]').val(),
                security = $form.find('#sec').val();

            if (!redirectUrl) {
                if ($form.find('[name="redirect_to"]').length) {
                    redirectUrl = $form.find('[name="redirect_to"]').val();
                } else if (location.search.indexOf('redirect_to') != -1) {
                    redirectUrl = location.search.split('redirect_to=')[1].substr(0, location.search.indexOf('&') >= 0 ? location.search.indexOf('&') : undefined);
                } else {
                    redirectUrl = undefined;
                }
            }

            $inputs.prop('disabled', true);

            $.post(wpbp_app.ajax_url, {
                action: 'wpbp-login',
                userName,
                password,
                remember,
                redirectUrl,
                security
            }).done(res => {
                $form.find('.is-loading').removeClass('is-loading');

                if (!res.error || res.error == 'valid') {
                    $inputs.prop('disabled', false);
                }

                document.location.href = res.redirecturl;
            });
        });
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/login.js